import { useRequestDemoPage } from "../../api/api-hooks";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTanstackTableUi from "../../common/ReactTanstackTableUi";
import { FaEdit } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import useCommonStore from "../../store/CommonStore";
import { getDateRangeFromSelectedValue } from "../../common/Constants";
import { useMemo, useState } from "react";
import DemoInteractionModal from "./SaveModel";

interface ShowDetailProps {
    isOpen: boolean;
    onCancel: () => void;
    selectedRow: RequestDemoRow | null
}

interface RequestDemoRow {
    id?: string,
    name?: string,
    email?: string,
    company?: string,
    designation?: string,
    description?: string,
    status: string,
    assigned_user?: string,
    created_at?: string,
    updated_at?: string
}

const ShowDetail: React.FC<ShowDetailProps> = ({
    isOpen,
    onCancel,
    selectedRow
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded shadow-md w-[800px]">
                <h2 className="text-lg font-semibold mb-4">Show Detail</h2>
                <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Customer Name
                    </label>
                    <input
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.name}
                        type="text"
                        name="name"
                        placeholder="Enter assign user"
                        disabled
                    />
                </div>
                {/* <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Customer Email
                    </label>
                    <input
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.email}
                        type="text"
                        name="name"
                        placeholder="Enter assign user"
                        disabled
                    />
                </div>
                <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Customer Designation
                    </label>
                    <input
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.designation}
                        type="text"
                        name="name"
                        placeholder="Enter assign user"
                        disabled
                    />
                </div>
                <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Customer Company
                    </label>
                    <input
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.company}
                        type="text"
                        name="name"
                        placeholder="Enter assign user"
                        disabled
                    />
                </div> */}
                <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Customer Description
                    </label>
                    <textarea
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.description}
                        placeholder="Enter assign user"
                        disabled
                    />
                </div>
                {/* <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Assigned User
                    </label>
                    <input
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.assigned_user}
                        type="text"
                        name="name"
                        placeholder="Enter assign user"
                        disabled
                    />
                </div>
                <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Status
                    </label>
                    <input
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.status}
                        type="text"
                        name="name"
                        placeholder="Enter assign user"
                        disabled
                    />
                </div>
                <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Created Date
                    </label>
                    <input
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.created_at}
                        type="text"
                        name="name"
                        placeholder="Enter assign user"
                        disabled
                    />
                </div>
                <div className="flex flex-col gap-2 my-4">
                    <label className="block text-lg font-semibold text-[#2E2E2E] mb-1">
                        Updated Date
                    </label>
                    <input
                        className="w-full px-4 py-3 rounded-xl border focus:border-primary_1 focus:ring-2 focus:ring-primary_1 outline-none transition-colors bg-white backdrop-blur-sm placeholder:text-[#2E2E2E4D]"
                        value={selectedRow?.updated_at}
                        type="text"
                        name="name"
                        placeholder="Enter assign user"
                        disabled
                    />
                </div> */}
                <div className="flex justify-end space-x-4">
                    <button
                        className="px-4 py-2 bg-green-600 text-white rounded"
                        onClick={onCancel}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

function prepareColumns(columnHelper: any, setShowModal: any, setShowDetail: any, setSelectedRow: any) {
    const renderWithTooltip = (text: string, maxWidth: string) => (
        <div
            className={`font-semibold text-gray-800 text-base truncate`}
            style={{ maxWidth }}
            title={text || "--"}
        >
            {text || "--"}
        </div>
    );

    return [
        columnHelper.accessor((row: any) => row.name, {
            id: "name",
            cell: (info: any) => {
                const original = info.row.original;
                return (
                    <div
                        className="flex flex-col gap-1 cursor-pointer"
                        onClick={() => {
                            setSelectedRow(original);
                            setShowDetail(true);
                        }}
                    >
                        {renderWithTooltip(original?.name, "150px")}
                    </div>
                );
            },
            header: () => <div>Name</div>,
        }),
        columnHelper.accessor((row: any) => row.email, {
            id: "email",
            cell: (info: any) => {
                const original = info.row.original;
                return renderWithTooltip(original?.email, "180px");
            },
            header: () => <div>Email</div>,
        }),
        columnHelper.accessor((row: any) => row.company, {
            id: "company",
            cell: (info: any) => {
                const original = info.row.original;
                return renderWithTooltip(original?.company, "150px");
            },
            header: () => <div>Company</div>,
        }),
        columnHelper.accessor((row: any) => row.assigned_user, {
            id: "assigned_user",
            cell: (info: any) => {
                const original = info.row.original;
                return renderWithTooltip(original?.assigned_user, "120px");
            },
            header: () => <div>Assigned User</div>,
        }),
        columnHelper.accessor((row: any) => row.status, {
            id: "status",
            cell: (info: any) => {
                const original = info.row.original;
                return renderWithTooltip(original?.status, "200px"); // Fixed width for readability
            },
            header: () => <div>Status</div>,
        }),
        columnHelper.accessor((row: any) => row.created_at, {
            id: "created_at",
            cell: (info: any) => {
                const original = info.row.original;
                return renderWithTooltip(
                    new Date(original?.created_at).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                    }),
                    "80px"
                );
            },
            header: () => <div>Created</div>,
        }),
        columnHelper.accessor((row: any) => row.actions, {
            id: "Actions",
            cell: (info: any) => {
                const original = info.row.original;
                return (
                    <div className="flex items-center space-x-4">
                        <FaEdit
                            className="text-blue-500 cursor-pointer hover:scale-110 transition-transform"
                            title="Edit status and assign user"
                            onClick={() => {
                                setSelectedRow(original);
                                setShowModal(true);
                            }}
                        />
                    </div>
                );
            },
            header: () => <div>Actions</div>,
        }),
    ];
}


function RequestDemoListTable() {
    const { selectedValue } = useCommonStore();
    const [showModal, setShowModal] = useState(false);
    const [showDetail, setShowDetail] = useState(false);
    // const [assignedUser, setAssignedUser] = useState('');
    // const [status, setStatus] = useState('');
    const [selectedRow, setSelectedRow] = useState<RequestDemoRow | null>(null);


    // const apiURL = process.env.REACT_APP_API_URL

    const dateRange = getDateRangeFromSelectedValue(selectedValue);

    const { startDate, endDate } = dateRange!;

    const { pageIndex, pageSize, getPaginationInfo } = usePagination();
    //   const { data: feedback, isLoading: isFeedbackLoading } = useFeedback();

    const { data: request_demo, isLoading: isRequestDemo, refetch: refetchRequestDemo } = useRequestDemoPage(
        pageIndex + 1,
        pageSize,
        startDate,
        endDate
    );

    const apiData = useMemo(() => {
        return Array.isArray(request_demo?.items) ? request_demo?.items : [];
    }, [request_demo]);

    const columnHelper = createColumnHelper();

    const paginationInfo = getPaginationInfo(request_demo);

    const columns = prepareColumns(columnHelper, setShowModal, setShowDetail, setSelectedRow);

    return (
        <div className="md:p-10 p-3">
            <ReactTanstackTableUi
                data={apiData}
                columns={columns}
                noDataMessage="Request Demo List"
                tableTitle="Request Demo List"
                disableRowHeight={true}
                pagination={true}
                externalPagination={paginationInfo}
                isLoading={isRequestDemo}
            />
            {showModal && (
                <DemoInteractionModal
                    isOpen={showModal}
                    onClose={() => {
                        setShowModal(false);
                        setSelectedRow(null);
                    }}
                    onSave={async () => {
                        setShowModal(false);
                        setSelectedRow(null);
                        await refetchRequestDemo();
                    }}
                    feedbackId={selectedRow?.id || ''}
                />
            )}

            {showDetail && (
                <ShowDetail
                    isOpen={showDetail}
                    onCancel={() => setShowDetail(false)}
                    selectedRow={selectedRow}
                />
            )}
        </div>
    );
}

function RequestDemo() {
    return (
        <div className=" flex flex-col gap-6 ">
            <div>
                <RequestDemoListTable />
            </div>
        </div>
    );
}

export default RequestDemo;
